<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <ClientsDropDownList
          :id="clientId"
          :clearable="true"
          @clientIdChange="(newValue) => this.clientId = newValue">
        </ClientsDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <UsersDropDownList
          :userId="userId"
          :clearable="true"
          label="Consultant"
          @userIdChange="(newValue) => this.userId = newValue"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-autocomplete
          v-model="jobTitle"
          :items="jobTitles"
          item-text="jobTitle"
          label="Job Title"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <EmployeeTypesDropdownList
          label="Consultant Type"
          :isRequired="false"
          :employeeType="employeeTypeId"
          @employee-type-change="(newValue) => this.employeeTypeId = newValue"
        ></EmployeeTypesDropdownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-switch
          class="my-auto"
          v-model="includeInactive"
          label="Include Inactive"
          @change="handleSearchClick"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col v-if="showDeactivateInBulk" sm="3">
        <v-btn
          block
          depressed
          color="primary"
          @click="handleDeactivateInBulk"
        >
          Deactivate in Bulk
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { UsersDropDownList } from '@/components/users'
import { ClientsDropDownList } from '@/components/clients'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { EmployeeTypesDropdownList } from '@/components/employeeTypes'

export default {
  props: [
    'jobTitles',
    'showDeactivateInBulk'
  ],
  components: {
    UsersDropDownList,
    ClientsDropDownList,
    FilterButtons,
    FilterButtonsSmall,
    EmployeeTypesDropdownList
  },
  data () {
    return {
      yesNoList: [
        { name: 'Yes', value: true },
        { name: 'No', value: false }
      ]
    }
  },
  computed: {
    ...mapFields('assignmentFilters', [
      'userId',
      'clientId',
      'jobTitle',
      'employeeTypeId',
      'active',
      'includeInactive'
    ])
  },
  methods: {
    ...mapActions('assignmentFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    },
    handleDeactivateInBulk () {
      this.$emit('deactivateInBulk')
    }
  }
}
</script>
